import { DeleteOutline } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import { Chip, SxProps, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerVisitStatus } from "~/__generated__";

type VisitStatusChipProps = {
    deleted?: boolean;
    value: GqlPlannerVisitStatus;
    sx?: SxProps<Theme>;
};

const PLANNER_VISIT_STATUS_VALUES = {
    [GqlPlannerVisitStatus.Unplanned]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "secondary" as const,
        labelKey: "VisitStatusChip.unplanned",
    },
    [GqlPlannerVisitStatus.Planned]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "secondary" as const,
        labelKey: "VisitStatusChip.planned",
    },
    [GqlPlannerVisitStatus.AwaitingReport]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "error" as const,
        labelKey: "VisitStatusChip.awaitingReport",
    },
    [GqlPlannerVisitStatus.AwaitingObservationApproval]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "warning" as const,
        labelKey: "VisitStatusChip.awaitingObservationApproval",
    },
    [GqlPlannerVisitStatus.AwaitingApproval]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "warning" as const,
        labelKey: "VisitStatusChip.awaitingApproval",
    },
    [GqlPlannerVisitStatus.AwaitingConfirm]: {
        icon: <HourglassEmptyIcon fontSize="small" />,
        color: "warning" as const,
        labelKey: "VisitStatusChip.awaitingConfirm",
    },
    [GqlPlannerVisitStatus.Approved]: {
        icon: <CheckCircleIcon fontSize="small" />,
        color: "success" as const,
        labelKey: "VisitStatusChip.approved",
    },
};

export default function VisitStatusChip({ deleted, value, sx }: VisitStatusChipProps) {
    const { t } = useTranslation("shared");
    const current = PLANNER_VISIT_STATUS_VALUES[value];

    return deleted ? (
        <Chip label={t("VisitStatusChip.deleted")} icon={<DeleteOutline />} color="warning" size="small" sx={sx} />
    ) : (
        <Chip label={t(current.labelKey)} icon={current.icon} color={current.color} size="small" sx={sx} />
    );
}
